import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalNotifyService } from 'src/app/core/services/modal-notify.service';
import { PropertiesSettings } from '../../core/configuration/properties-settings';
import { HelpersService } from '../../core/services/helpers.service';
import { OperationsService } from '../../core/services/operations.service';
import { IncassoSoggettoAdapter } from '../components/fascicolo/incassi-ripartizione/incasso-soggetto-adapter';
import { Controparte } from '../models/controparte';
import { FascicoloFull } from '../models/fascicolo/fascicolo-full';
import { Incasso } from '../models/incasso';
import { IncassoSoggetto } from '../models/incasso-soggetto';
import { PetitumRevisione } from '../models/petitum-revisione';
import { SezioneEconomica } from '../models/sezioni/sezione-economica';
import { SoggettoPratica } from '../models/tipologiche/soggetto-pratica';
import { NumericOperationManager } from '../utils/numeric-operation-manager';
import { BaseForm } from './base-Form';

export abstract class IncassoFormRipartizione extends BaseForm {

  request: IncassoSoggetto;
  incasso: Incasso;
  fascicolo: FascicoloFull;
  ripartizioneForm: FormGroup;
  soggettoOptions: SoggettoPratica[]=[];
  msgNoBeneficiari: string;

  sezioneEconomica: SezioneEconomica;
  lastRevisionePetitum: PetitumRevisione;

  totaleIncasso: number;
  totaleIncassoDefault:number;

  abstract getRipartizioneIncasso(): IncassoSoggetto;
  abstract getUrlReadSezioneControparti(): string;
  abstract getUrlReadSezioneEconomica(): string;
  abstract getRequest(ripartizione: IncassoSoggetto);

  constructor(protected operationService: OperationsService,
              protected campiForm: FormBuilder,
              protected helpers: HelpersService,
              protected modalNotifyService: ModalNotifyService){
    super();
  }

 initRequest() {
    this.request = new IncassoSoggettoAdapter(this.getRipartizioneIncasso(), this.incasso).incassoSoggetto;
    this.totaleIncassoDefault=this.getTotale(this.incasso);
    this.onChangePercentuale(this.request.percentualeIncasso);
  }

  createForm() {
      this.initRequest();
      this.ripartizioneForm = this.campiForm.group({
      soggetto: [this.request.soggetto, Validators.required],
      percentualeIncasso: [this.request.percentualeIncasso, Validators.required],
      totale: [this.request.incasso ? this.totaleIncasso : 0]
    });
  }

  populateSelect() {
    if (this.soggettoOptions.length === 0) {
      const tipoPratica = this.fascicolo.praticaBase.tipoPratica.endpoint;
      if (PropertiesSettings.ID_TENANTS_FS()) {
        this.helpers.getSoggetti().subscribe(response => {
          if (PropertiesSettings.PRATICHE_CON.includes(tipoPratica)) {
            this.soggettoOptions = response.filter(el => el.sigla !== 'CD');
          } else if (PropertiesSettings.PRATICHE_CD.includes(tipoPratica)) {
            this.soggettoOptions = response.filter(el => el.sigla !== 'CON');
          } else {
            this.soggettoOptions = response;
          }
        });
      } else {
        this.helpers.getSoggetti().subscribe(response => this.soggettoOptions = response);
      }
    }
  }

  onChangePercentuale(event){
    if(event){
      (event===0) ? this.request.incasso.importo=0 : this.totaleIncasso = this.totaleIncassoDefault*(event/100);
    }
    else{
      this.totaleIncasso=this.totaleIncassoDefault;
    }
  }

  update() {
    this.getRequest(this.request);
  }

  getTotale(incasso: Incasso):number {
    let totale = this.getSum( incasso.importo ? incasso.importo : '0',
    incasso.interessi ? incasso.interessi : '0',
    incasso.spese ? incasso.spese : '0',
    incasso.compensoAvvocati ? incasso.compensoAvvocati : '0');
    return Number.parseFloat(totale);
  }

  getSoggettoLabel(soggettoPagatore: Controparte): string {
    let result = '';
    if (soggettoPagatore && soggettoPagatore.parte && soggettoPagatore.parte.tipoPersona) {
      if (soggettoPagatore.parte.tipoPersona.label === PropertiesSettings.LABEL_TIPO_PERSONA_FISICA) {
        result = soggettoPagatore.parte.cognome + ' ' + soggettoPagatore.parte.nome;
      }
      if (soggettoPagatore.parte.tipoPersona.label === PropertiesSettings.LABEL_TIPO_PERSONA_GIURIDICA) {
        result = soggettoPagatore.parte.ragioneSociale;
      }
    }
    return result;
  }

//   getControparte(obj: any) {
//     if (obj && obj.id) {
//       this.request.soggettoPagatore =  this.soggettiPagatoriOptions.filter(controparte => { return controparte.id === obj.id; })[0];
//     }
//   }

  getSum(...args: string[]) {
    return NumericOperationManager.getSum(args);
  }

  stringToNumber(a: string): number {
    return Number(a);
  }

}
